import { render } from "./DesiredSemesterModulesModal.vue?vue&type=template&id=bd3079c0"
import script from "./DesiredSemesterModulesModal.vue?vue&type=script&lang=js"
export * from "./DesiredSemesterModulesModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__